import '../../../base_builders/vertical/rcp/rcp_base_builder';

//Its required for comments
import RcmgSpot from '../../../../assets/js/RCMG_V2/RcmgSpot.js';

import VideoCalendarConfig from '../../../../assets/js/YCalendar/VideoCalendarConfigs';
VideoCalendarConfig();

// import rc_newsletters from '../../../../assets/top/rc-newsletters-v2.js';
import Newsletters from '../../../../assets/js/Newsletters/Newsletters';
Newsletters();